import { render, staticRenderFns } from "./VerificacionCuenta.vue?vue&type=template&id=01fd2e36&scoped=true"
import script from "./VerificacionCuenta.vue?vue&type=script&lang=js"
export * from "./VerificacionCuenta.vue?vue&type=script&lang=js"
import style0 from "./VerificacionCuenta.vue?vue&type=style&index=0&id=01fd2e36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd2e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fd2e36')) {
      api.createRecord('01fd2e36', component.options)
    } else {
      api.reload('01fd2e36', component.options)
    }
    module.hot.accept("./VerificacionCuenta.vue?vue&type=template&id=01fd2e36&scoped=true", function () {
      api.rerender('01fd2e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/verificacionCuenta/VerificacionCuenta.vue"
export default component.exports